<template>
    <div class="auth--background" v-if="!$store.getters['base/auth/isAuthenticated']"
         :style="{'background-image': 'url('+organisation.background+')'}"
    >
        <div class="auth">
            <div class="auth__logo" :class="{ 'large': displayLargerLogo }">
                <img :src="organisation.logoLogin" fluid/>
            </div>
            <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut" appear>
                <section class="auth--container" v-show="!formIsHidden">
                    <div>
                        <div class="text-right mb-2" v-if="hideButtonIsDisplay">
                            <i class="oi oi-x cursor--pointer" @click.self="formIsHidden = !formIsHidden"></i>
                        </div>
                        <slot></slot>
                    </div>
                </section>
            </transition>
            <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut">
                <div
                        class="auth--login-btn"
                        @click="formIsHidden = !formIsHidden"
                        v-if="formIsHidden && hideButtonIsDisplay">
                    <div class="mx-auto">Connexion</div>
                </div>
            </transition>
        </div>
    </div>
</template>

<script>
    import {APP_ORGANISATION} from '@/utils/types/setting'

    export default {
        name: 'auth-model',
        props: {
            hideForm: Boolean,
            hasHideButton: Boolean
        },
        mounted() {
            this.displayForm()
            // window.addEventListener('resize', this.displayForm)
        },
        data: function () {
            return {
                formIsHidden: this.hideForm,
                hideButtonIsDisplay: this.hasHideButton
            }
        },
        computed: {
            organisation() {
                return this.$store.state.base.setting[APP_ORGANISATION]
            },
            displayLargerLogo() {
                return window.location.hostname == 'orleans-metropole.alterego-digital.eu' ||
                    window.location.hostname == 'capio.alterego-digital.eu'
            }
        },
        methods: {
            displayForm() {
                this.formIsHidden = window.innerWidth < 768 ? this.hasHideButton : false;
                this.hideButtonIsDisplay = window.innerWidth < 768 ? this.hideForm : false;
            }
        }
    }
</script>

<style lang="scss">
    .auth--background .auth .auth--container #auth--form {
        border-radius: 5px !important;
    }

    @media (min-width: 1500px){
        .auth--background .auth .auth--container {
            top: -15%;
        }
    }

</style>
